export default __webpack_public_path__ + "static/astrorei-sviluppo-software-in-outsourcing-quale-modalità-scegliere-b375e31cfe3a9f0c41af8250c1c012c3.jpg";